import * as CONSTANTS from '../../shared/constants';

const { GRID_SIZE } = CONSTANTS;

export const renderWalls = (ctx, walls, destructibleWallImage, indestructibleWallImage) => {
  walls.forEach(wall => {
    if (wall.melting) {
      // Render melting wall with semi-transparent, flickering effect
      const opacity = 0.3 + Math.sin(Date.now() * 0.01) * 0.2;
      
      if (wall.destructible && destructibleWallImage) {
        // Draw the destructible wall image with melting effect
        ctx.globalAlpha = opacity;
        ctx.drawImage(destructibleWallImage, wall.x * GRID_SIZE, wall.y * GRID_SIZE, GRID_SIZE, GRID_SIZE);
        
        // Add orange glow overlay for melting effect
        ctx.fillStyle = `rgba(255, 140, 0, 0.5)`;
        ctx.fillRect(wall.x * GRID_SIZE, wall.y * GRID_SIZE, GRID_SIZE, GRID_SIZE);
        ctx.globalAlpha = 1;
      } else {
        // Fallback to solid color rendering
        ctx.fillStyle = `rgba(139, 69, 19, ${opacity})`; // Brown with varying opacity
        ctx.fillRect(wall.x * GRID_SIZE, wall.y * GRID_SIZE, GRID_SIZE, GRID_SIZE);
        
        // Add orange glow effect for melting
        ctx.fillStyle = `rgba(255, 140, 0, ${opacity * 0.5})`;
        ctx.fillRect(wall.x * GRID_SIZE + 2, wall.y * GRID_SIZE + 2, GRID_SIZE - 4, GRID_SIZE - 4);
      }
    } else if (wall.suddenDeath) {
      // Sudden death walls - dark red with pulsing effect
      const pulseFactor = 0.7 + Math.sin(Date.now() * 0.008) * 0.3; // Pulsing between 0.4 and 1.0
      
      if (indestructibleWallImage) {
        // Draw the indestructible wall image first
        ctx.drawImage(indestructibleWallImage, wall.x * GRID_SIZE, wall.y * GRID_SIZE, GRID_SIZE, GRID_SIZE);
        
        // Add dark red overlay with pulsing effect
        ctx.fillStyle = `rgba(100, 0, 0, ${pulseFactor * 0.8})`;
        ctx.fillRect(wall.x * GRID_SIZE, wall.y * GRID_SIZE, GRID_SIZE, GRID_SIZE);
        
        // Add glowing red border
        ctx.strokeStyle = `rgba(200, 0, 0, ${pulseFactor})`;
        ctx.lineWidth = 2;
        ctx.strokeRect(wall.x * GRID_SIZE + 1, wall.y * GRID_SIZE + 1, GRID_SIZE - 2, GRID_SIZE - 2);
      } else {
        // Fallback to solid color rendering
        ctx.fillStyle = `rgba(70, 0, 0, ${pulseFactor})`;
        ctx.fillRect(wall.x * GRID_SIZE, wall.y * GRID_SIZE, GRID_SIZE, GRID_SIZE);
        
        // Add glowing red border
        ctx.strokeStyle = `rgba(200, 0, 0, ${pulseFactor})`;
        ctx.lineWidth = 2;
        ctx.strokeRect(wall.x * GRID_SIZE + 1, wall.y * GRID_SIZE + 1, GRID_SIZE - 2, GRID_SIZE - 2);
      }
    } else {
      if (wall.destructible && destructibleWallImage) {
        // Draw the destructible wall image
        ctx.drawImage(destructibleWallImage, wall.x * GRID_SIZE, wall.y * GRID_SIZE, GRID_SIZE, GRID_SIZE);
      } else if (!wall.destructible && indestructibleWallImage) {
        // Draw the indestructible wall image
        ctx.drawImage(indestructibleWallImage, wall.x * GRID_SIZE, wall.y * GRID_SIZE, GRID_SIZE, GRID_SIZE);
      } else {
        // Use solid color fallback
        ctx.fillStyle = wall.destructible ? '#8b4513' : '#555';
        ctx.fillRect(wall.x * GRID_SIZE, wall.y * GRID_SIZE, GRID_SIZE, GRID_SIZE);
      }
    }
  });
};